import { FC } from "react";

import { Translate } from "@/components/Application/Translate";

import { ProcedureTrainingCompetency } from "@/model/Procedure/ProcedureTrainingCompetency";

export interface IProcedureCompetencyListItemProps {
	Competence: ProcedureTrainingCompetency;
}
export const ProcedureCompetencyListItem: FC<
	IProcedureCompetencyListItemProps
> = (props) => {
	const getCompetencyId = (competence: ProcedureTrainingCompetency): number => {
		switch (competence) {
			case "None":
				return 0;
			case "Review":
				return 11;
			case "Course":
				return 10;
			case "CourseReview":
				return 12;
		}
	};

	const prettify = (competence: ProcedureTrainingCompetency) => {
		if (competence === "None") {
			return (
				<Translate String="Competencies.ProcedureEdit.None">
					[{competence}]
				</Translate>
			);
		}

		return (
			<Translate String={`Competencies.ProcedureEdit.${competence}`}>
				{competence}
			</Translate>
		);
	};

	return (
		<option value={getCompetencyId(props.Competence)}>
			      {prettify(props.Competence)}
			    
		</option>
	);
};
